import React from "react";
import _ from 'lodash';
import { InternalRolePermissionTypes, G_EXPORT_TRANSACTION, PAY_OVERVIEW_STOP_PAYMENT, U_VIEW_USERS, PAY_NOTES_ADD_NOTES, REGISTER_COMPANIES } from '../../config/PermissionTypes';

export default function InternalRolePermissions(props) {
    const { permissions, nonEditablePermissions, handlePermissionUpdate } = props;

    const roleHasAllPerimssions = () => {
        return _.difference(InternalRolePermissionTypes, permissions).length === 0;
    }

    const handleSelectAll = () => {
        let existingPermissions = nonEditablePermissions ? nonEditablePermissions : [];
        if (!roleHasAllPerimssions()) {
            handlePermissionUpdate("permissions", [...InternalRolePermissionTypes, ...existingPermissions]);
        } else {
            handlePermissionUpdate("permissions", [...existingPermissions]);
        }
    }

    const handlePermissionToggle = (e, permissionCode) => {
        let currentPermissions = permissions;
        if (e.target.checked) {
            currentPermissions.push(permissionCode);
        } else {
            currentPermissions = currentPermissions.filter(p => p !== permissionCode)
        }
        handlePermissionUpdate("permissions", [...currentPermissions]);
    }

    return (
        <><div className="row">
            <div className="col">
                {/* <p>Use the checkboxes below to select all or choose which permissions apply to the new roles.</p> */}
                <div className="permissions-select-all">
                    <input
                        type="checkbox"
                        checked={roleHasAllPerimssions()}
                        onChange={() => handleSelectAll()}
                        data-testid="role-select-all-permissions"
                    />
                    <span className="checkmark"></span>{" "}
                    <label>Select All</label>
                </div>
            </div>
        </div>
            <div className="row">
                <div className="col">
                    <p className="permission-title">Dashboard</p>
                    <div className="permission-checkbox-option">
                        <label>No Dashboard related permissions available at this time.</label>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <p className="permission-title">Payment Pages</p>
                    <div className="permission-checkbox-option">
                        <input
                            type="checkbox"
                            checked={permissions?.includes(G_EXPORT_TRANSACTION)}
                            onChange={e => handlePermissionToggle(e, G_EXPORT_TRANSACTION)}
                            data-testid="payment-permission-export-data"
                        />
                        <span className="checkmark"></span>{" "}
                        <label>Export Data</label>
                    </div>
                    <div className="permission-checkbox-option">
                        <input
                            type="checkbox"
                            checked={permissions?.includes(PAY_OVERVIEW_STOP_PAYMENT)}
                            onChange={e => handlePermissionToggle(e, PAY_OVERVIEW_STOP_PAYMENT)}
                            data-testid="payment-permission-stop-payment"
                        />
                        <span className="checkmark"></span>{" "}
                        <label>Stop Payment</label>
                    </div>
                    <div className="permission-checkbox-option">
                        <input
                            type="checkbox"
                            checked={permissions?.includes(PAY_NOTES_ADD_NOTES)}
                            onChange={e => handlePermissionToggle(e, PAY_NOTES_ADD_NOTES)}
                            data-testid="payment-permission-add-notes"
                        />
                        <span className="checkmark"></span>{" "}
                        <label>Add Notes</label>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <p className="permission-title">User Admin</p>
                    <div className="permission-checkbox-option">
                        <input
                            type="checkbox"
                            checked={permissions?.includes(U_VIEW_USERS)}
                            onChange={e => handlePermissionToggle(e, U_VIEW_USERS)}
                            data-testid="user-admin-permission-view-users"
                        />
                        <span className="checkmark"></span>{" "}
                        <label>View Users</label>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <p className="permission-title">Register Companies</p>
                    <div className="permission-checkbox-option">
                        <input
                            type="checkbox"
                            checked={permissions?.includes(REGISTER_COMPANIES)}
                            onChange={e => handlePermissionToggle(e, REGISTER_COMPANIES)}
                            data-testid="register-companies-permission"
                        />
                        <span className="checkmark"></span>{" "}
                        <label>Register Companies</label>
                    </div>
                </div>
            </div></>
    );
}